// 大布局
import RefPage from "./page/index";
import Header from "./page/page-header";
import Nav from "./page/nav";
import Aside from "./page/aside";
import Content from "./page/content";
import Footer from "./page/page-footer";
import "./index.scss";
// @ts-ignore
var CnLayoutPage = RefPage;
CnLayoutPage.Header = Header;
CnLayoutPage.Nav = Nav;
CnLayoutPage.Aside = Aside;
CnLayoutPage.Content = Content;
CnLayoutPage.Footer = Footer;
export { Header as CnLayoutHeader, Nav as CnLayoutNav, Aside as CnLayoutAside, Content as CnLayoutContent, Footer as CnLayoutFooter };
export { CnLayoutPage };
export { default as CnLayoutSection } from "./section";
export { default as CnLayoutBlock } from "./block";

// 小布局
export { default as CnLayoutGrid } from "./grid";
export { default as CnLayoutRow } from "./row";
export { default as CnLayoutCol } from "./col";
export { default as CnLayoutCell } from "./cell";
// export { default as CnP } from './p';
// export { default as CnText } from './text';

export { default as CnLayoutFixedPoint } from "./fixed-point";
export { default as CnLayoutFixedContainer } from "./fixed-container";
export { default as CnLayoutSpace } from "./space";
export default CnLayoutPage;